<div class="{{localService.selectedLanguageCode}}" *ngIf="localService.isPageActionLoaded() && localService.languageContent && localService.languageContent.access">
  <div *ngIf="!localService.isPageAllowed()">
    <app-full-page-message></app-full-page-message>
  </div>
  <div *ngIf="localService.isPageAllowed() && source" class="center" style="max-width:800px;">
    <div class="row" *ngIf="!source.content || source.content.length == 0">
      <div class="col-md-12" style="text-align:center;margin-top:10%">
        <div style="font-size: 25px;">{{localService.languageContent.access.no_access_yet}}</div>
        <br />
        <i class="material-icons" (click)="onOpenAddAccess()" *ngIf="localService.isActionAllowed(1)" style="font-size: 100px;">add_circle_outline</i>
      </div>
    </div>
    <div *ngIf="source.content && source.content.length > 0">
      <div class="banner center" style="max-width:1000px;">
        <div class="row freeze_height">
          <div class="col-9">
            <label style="font-weight: normal; margin-left: 30px;">
              <input type="checkbox" [(ngModel)]="isShowActive" (change)="onFilter()" />
              <span class="normal_color">{{localService.languageContent.access.show_active}}</span>
            </label>
            <label style="font-weight: normal; margin-left: 30px;">
              <input type="checkbox" [(ngModel)]="isShowInActive" (change)="onFilter()" />
              <span class="normal_color">{{localService.languageContent.access.show_inactive}}</span>
            </label>
          </div>
          <div class="col-3">
            <div class="icon_action_header">
              <i class="material-icons on_language_changed" style="float:left;" (click)="onLoad(true)">replay_circle_filled</i>
              <i class="material-icons" *ngIf="localService.isActionAllowed(1)" (click)="onOpenAddAccess()">add_circle_outline</i>
            </div>
          </div>
        </div>
        <div class="row row_header freeze_col freeze_height">
          <div class="col-4">
            {{localService.languageContent.access.access_type}}
          </div>
          <div class="col-4">
            {{localService.languageContent.access.access_range}}
          </div>
          <div class="col-4">
            {{localService.languageContent.access.action_on}}
          </div>
        </div>
        <div class="custom_rows_body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
          <div class="row styled_row freeze_col" *ngFor="let item of wrappers">
            <div class="col-4">
              <span *ngIf="localService.isActionAllowed(5)"><i *ngIf="item.v3 == '1'" class="material-icons delete_icon icon_adjust" (click)="onActiveInactiveStatus(item.key)">cancel</i>&nbsp;</span>
              <span *ngIf="item.v3 == '0'">&nbsp;&nbsp;&nbsp;</span>
              <span [ngStyle]="{'color' : item.v3 == '0' ? 'red' : 'green'}">{{getText(1,item.v2)}}</span>
            </div>
            <div class="col-4">
              {{getText(2,item.v1)}}
            </div>
            <div class="col-4 en">
              {{item.v4 | localDate}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
